export default __webpack_public_path__ + "images/4B.8ca1c83.png";